(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/bankid/poll.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/bankid/poll.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.bankid.Poll = Marionette.View.extend({
    template: function template(data) {
      if (this.progressStatus < 3) {
        return svs.player_login.templates.bankid_poll_start(data);
      }

      return svs.player_login.templates.bankid_app_started(data);
    },
    behaviors: [{
      behaviorClass: svs.player_login.behaviors.BankIDErrorHandling
    }],
    source: {
      'ios-hybrid-mobile': 5,
      'android-hybrid-mobile': 5,
      'ios-hybrid-tablet': 6,
      'web-mobile': 1,
      'web-tablet': 2,
      'web-desktop': 3
    },
    events: {
      'click .js-open-bankid-with-ssn': 'onFallbackLinkClick',
      'click .js-open-bankid': 'onOpenBankIdClick',
      'click .js-cancel-poll': 'onCancelPollClick',
      'click .js-bankid-ssn-login': 'onBankIdSsnLoginClick'
    },
    initialize: function initialize() {
      delete this.pollingTimeoutId;
      this.progressStatus = 0;
      delete this.autoStartToken;
      delete this.loader;
      this.loginStartTime = svs.components.Storage.browser.get('loginStartTime', 'player-login');
      this.errorRetries = 2;
      this.qrCodeRetries = !this.model.get('isSsnLogin') ? 5 : 0;
    },
    onAttach: function onAttach() {
      var _this = this;

      var logger = svs.core.log.getLogger('modules:player-login');

      if (!this.model.get('autoStartToken')) {
        logger.error("No ast in model, server side data: ".concat(svs.player_login.data.login.ast));
      }

      if (!svs.core.detect.formfactor.mobile()) {
        this.loader = new svs.components.Loader('.js-bankid-loader-large-inverted');
        this.loader.show(300, 'inverted');
      }

      this.pollingTimeoutId = setTimeout(function () {
        _this.pollCustomerLogin();
      }, 500);

      if (this.model.get('startBankId')) {
        this.startBankId();
      } else {
        this.qrCodeGenerate();
      }
    },
    onOpenBankIdClick: function onOpenBankIdClick(e) {
      e.preventDefault();
      svs.utils.url.navigate(svs.player_login.utils.url.getBankIDAppUrl(this.model.get('autoStartToken')));
    },
    onCancelPollClick: function onCancelPollClick(e) {
      e.preventDefault();
      this.abortCustomerLogin();
      this.cancelPoll();
      svs.player_login.router.navigate("/?returnUrl=".concat(this.model.get('returnUrl')), true);
    },
    onFallbackLinkClick: function onFallbackLinkClick(e) {
      e.preventDefault();
      this.model.set('isSsnFallback', true);
      this.model.set('startBankId', false);
      svs.player_login.router.navigate('/mobilt-bankid', true);
    },
    onBankIdSsnLoginClick: function onBankIdSsnLoginClick(e) {
      var _this2 = this;

      var logger = svs.core.log.getLogger('module:player-login');
      e.preventDefault(); 

      svs.core.deviceSession.set('bankIdLoginMethod', 'customer_login', 'ssn', function (err) {
        if (err) {
          logger.debug('Error when saving bankid login method to device session.');
        }

        _this2.abortCustomerLogin();

        _this2.cancelPoll();

        _this2.model.set('isSsnLogin', true);

        _this2.model.set('isSsnFallback', false);

        _this2.model.set('startBankId', false);

        svs.player_login.router.navigate('/mobilt-bankid', true);
      });
    },
    startBankId: function startBankId() {
      var url = svs.player_login.utils.url.getBankIDAppUrl(this.model.get('autoStartToken'));
      svs.utils.url.navigate(url);
    },

    storeCustomerType: function storeCustomerType(customerType, callback) {
      svs.components.Storage.browser.set('customerType', 'customer_registration', customerType, svs.components.Storage.constants.EXPIRES_1H, callback);
    },
    cancelPoll: function cancelPoll() {
      var options = {
        method: 'POST',
        path: '/player/cancel',
        context: this,
        data: {
          autoStartToken: this.model.get('autoStartToken')
        }
      };
      svs.core.jupiter.call(options, function (response) {
        svs.core.log.getLogger('modules:player-login').info("Cancel poll: ".concat(response));
      }, function (xhr) {
        var errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;
        svs.core.log.getLogger('modules:player-login:error-codes').info(errorCode);
      });
    },

    pollCustomerLogin: function pollCustomerLogin() {
      var options = {
        method: 'POST',
        path: '/player/authenticate/login',
        context: this,
        data: {
          autoStartToken: this.model.get('autoStartToken'),
          source: this.source[svs.core.data.capabilities.channel] || 1
        }
      };
      svs.core.log.getLogger('modules:player-login').debug("ast: ".concat(this.model.get('autoStartToken')));
      svs.core.jupiter.call(options, function (response) {
        var _this3 = this;

        var successEvent = {
          category: 'Users',
          action: 'Login Success',
          opt_label: "bankid".concat(svs.core.detect.formfactor.mobile() || this.model.get('sameDevice') ? '' : this.model.get('isSsnLogin') ? ' ssn' : ' qr')
        },
            newCustomerEvent = {
          category: 'Users',
          action: 'Customer Registration'
        };
        var customerType, isBlocked, lastLoginTime;
        var dateNow = Date.now(); 

        var afterLastLoginTimeSetCallback;
        var self = this,
            logger = svs.core.log.getLogger('modules:player-login');

        if (this.progressStatus <= 2 && (response.progressStatus > 2 || response.session)) {
          this.loader && this.loader.hide();
          this.progressStatus = response.progressStatus;
          this.render();
        } else {
          this.progressStatus = response.progressStatus;
        }

        if (response.session || response.progressStatus === 6) {
          if (this.loginStartTime) {
            successEvent.opt_value = Date.now() - this.loginStartTime;
          }

          svs.components.analytics.trackEvent(successEvent, this);
          isBlocked = response && response.session && response.session.isBlocked;

          if (isBlocked || response.userNotifications && (response.userNotifications.HAS_SUSPENSION || response.userNotifications.SHOW_SUSP_REMINDER)) {
            if (isBlocked) {
              this.model.set('action', 'show_national_suspension_message');
            } else if (response.userNotifications.HAS_SUSPENSION) {
              this.model.set('action', 'show_suspension');
            } else {
              this.model.set('action', 'show_suspension_reminder');
            }

            afterLastLoginTimeSetCallback = function afterLastLoginTimeSetCallback() {
              svs.player_login.router.navigate('/spelpaus', true);
            };
          } else {
            afterLastLoginTimeSetCallback = function afterLastLoginTimeSetCallback() {
              svs.utils.url.navigate(self.model.get('returnUrl'));
            };
          }

          lastLoginTime = response && response.lastLoginTime || ''; 

          if (lastLoginTime === '') {
            logger.info('No lastLoginTime in session response');
          } else if (svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, true) === svs.player_login.utils.date.format(dateNow, true)) {
            logger.info("lastLoginTime from backend (".concat(lastLoginTime, ") seems to be currentLoginTime. It is the same date, same hour, same minute and same second"));
          } else {
            logger.info("lastLoginTime from backend (".concat(lastLoginTime, ")"));
          }

          if (response.userNotifications && response.userNotifications.PART_OF_CAMPAIGN) {
            svs.core.userSession.set('partofcampaign', true, function () {
              svs.core.userSession.set('lastLoginTime', svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, false), afterLastLoginTimeSetCallback);
            }); 
          } else {
            svs.core.userSession.set('lastLoginTime', svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, false), afterLastLoginTimeSetCallback);
          }
        } else if (response.progressStatus === 20 || response.progressStatus === 21) {
          response.deviceId = undefined;
          response.requestId = undefined;
          response.requestInfo = undefined;
          response.ssn = this.model.get('ssn');

          if (this.model.get('returnNewCustomer')) {
            response.returnUrl = this.model.get('returnUrl'); 
          }

          if (response.progressStatus === 20) {
            newCustomerEvent.opt_label = 'started_new_customer';
            customerType = 'new';
          } else {
            newCustomerEvent.opt_label = 'started_retail_customer';
            customerType = 'retail';
          }

          svs.components.analytics.trackEvent(newCustomerEvent, function () {
            this.storeCustomerType(customerType, function () {
              svs.utils.form.postToUrl(svs.utils.urlMapping.get('customerRegistrationCompletion'), response, 'POST');
            });
          }, this);
        } else if (response.progressStatus) {
          this.pollingTimeoutId = setTimeout(function () {
            _this3.pollCustomerLogin();
          }, 1000);
          svs.events.publish('/core/session/progressstatus', response.progressStatus);
        } else {
          svs.components.analytics.trackEvent({
            category: 'Users',
            action: 'Login Failure',
            opt_label: 'bankid',
            opt_value: '666'
          });
          this.handleBankIDError();
        }
      }, function (xhr) {
        var _this4 = this;

        var errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;

        if (errorCode && errorCode === 666 && this.errorRetries > 0) {
          this.errorRetries = this.errorRetries - 1;
          this.pollingTimeoutId = setTimeout(function () {
            _this4.pollCustomerLogin();
          }, 1000);
          svs.core.log.getLogger('modules:player-login').info('Received network error, retrying');
        } else if (!this.model.get('isSsnLogin') && errorCode && errorCode === 56 && this.qrCodeRetries > 0) {
          this.qrCodeRetries = this.qrCodeRetries - 1;
          svs.player_login.radio.request('autoStartToken', true).done(function (autoStartToken) {
            _this4.model.set('autoStartToken', autoStartToken);

            _this4.model.set('sameDevice', false);

            history.pushState({}, '', "poll?".concat(_this4.model.toQueryString('bankid')));

            _this4.qrCodeGenerate();

            _this4.pollingTimeoutId = setTimeout(function () {
              _this4.pollCustomerLogin();
            }, 1000);
          }).fail(function (err) {
            _this4.triggerMethod('bankIDError', err);
          });
          svs.core.log.getLogger('modules:player-login').info('QR code polling timed out, re-generate QR code and poll again');
        } else {
          if (this.loader) {
            this.loader.hide();
          }

          svs.components.analytics.trackEvent({
            category: 'Users',
            action: 'Login Failure',
            opt_label: 'bankid',
            opt_value: errorCode || 666
          });
          svs.core.log.getLogger('modules:player-login:error-codes').info(errorCode);
          this.handleBankIDError(xhr);
        }
      });
    },
    handleBankIDError: function handleBankIDError(err) {
      this.triggerMethod('bankIDError', err);
    },

    abortCustomerLogin: function abortCustomerLogin() {
      clearTimeout(this.pollingTimeoutId);
    },
    onDestroy: function onDestroy() {
      if (this.pollingTimeoutId) {
        clearTimeout(this.pollingTimeoutId);
      }
    },
    qrCodeGenerate: function qrCodeGenerate() {
      var qrCodeId = this.model.get('autoStartToken');

      if (qrCodeId !== undefined && qrCodeId.length > 0) {
        qrCodeId = "bankid:///?autostarttoken=".concat(qrCodeId);
        $('#qrCode').empty().qrcode({
          size: 120,
          color: '#3a3',
          text: qrCodeId
        });
      }
    }
  });
})(Backbone, _, svs);
 })(window);